<template>
  <div class="customise-hike-list-line-style">
    <LineStyleEditor
      :color="prefs.color"
      :thickness="prefs.thickness"
      :opacity="prefs.opacity"
      :color-label="$t('base_map_dialog.customise_overlay_line_style_view.line_colour')"
      :thickness-label="$t('base_map_dialog.customise_overlay_line_style_view.line_thickness')"
      :opacity-label="$t('base_map_dialog.customise_overlay_line_style_view.line_opacity')"
      @update:color="update({ color: $event })"
      @update:thickness="update({ thickness: $event })"
      @update:opacity="update({ opacity: $event })"
      @reset="resetHikeListStyle(listId)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'vuex';
import LineStyleEditor from './LineStyleEditor.vue';
import { HikeListLinePrefs, hikeListStyleFor } from '../../../utils/hikeListOverlay';

/**
 * Line style for one hike list — the same editor as the other overlays'
 * "line style" screens. Reached from the cog on that list's row in the picker.
 * The store saves the change, repaints the map and syncs it to the account.
 */
export default defineComponent({
  name: 'CustomiseHikeListLineStyleView',

  components: { LineStyleEditor },

  props: {
    listId: { type: String, required: true },
  },

  computed: {
    ...mapState('mapDataOverlays', ['hikeListStyles']),
    prefs(): HikeListLinePrefs {
      return hikeListStyleFor(this.hikeListStyles, this.listId);
    },
  },

  methods: {
    ...mapActions('mapDataOverlays', ['setHikeListStyle', 'resetHikeListStyle']),
    update(change: Partial<HikeListLinePrefs>) {
      this.setHikeListStyle({ id: this.listId, prefs: { ...this.prefs, ...change } });
    },
  },
});
</script>

<style scoped>
.customise-hike-list-line-style {
  padding: 16px;
  padding-bottom: 24px;
}
</style>
